var _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImageAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 24,
    cy: 24,
    r: 22,
    fill: "#5B86EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9987 12.332C20.942 12.332 18.457 14.817 18.457 17.8737C18.457 20.872 20.802 23.2987 23.8587 23.4037C23.952 23.392 24.0454 23.392 24.1154 23.4037C24.1387 23.4037 24.1504 23.4037 24.1737 23.4037C24.1854 23.4037 24.1854 23.4037 24.197 23.4037C27.1837 23.2987 29.5287 20.872 29.5404 17.8737C29.5404 14.817 27.0554 12.332 23.9987 12.332Z",
    fill: "#A020FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9291 26.5103C26.6741 24.3403 21.3657 24.3403 18.0874 26.5103C16.6057 27.502 15.7891 28.8436 15.7891 30.2786C15.7891 31.7136 16.6057 33.0436 18.0757 34.0236C19.7091 35.1203 21.8557 35.6686 24.0024 35.6686C26.1491 35.6686 28.2957 35.1203 29.9291 34.0236C31.3991 33.032 32.2157 31.702 32.2157 30.2553C32.2041 28.8203 31.3991 27.4903 29.9291 26.5103Z",
    fill: "#A020FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageAvatar);
export default __webpack_public_path__ + "static/media/NoImageAvatar.de553cc34052d8ccc06b5a5783b2309b.svg";
export { ForwardRef as ReactComponent };